import { io } from "socket.io-client";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Grid,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import { styled } from "@mui/system";
import CardLayout from "../../../layouts/CardLayout";
import { IMAGE_BASE, SOCKET_URL } from "../../../utils/constants";
import { toast } from "react-toastify";
import { useSocket } from "../../../services/SocketProvider";

const InfoBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#5e5e62",
  color: "#fff",
  padding: "16px",
  borderRadius: "8px",
  textAlign: "center",
  marginTop: theme.spacing(2),
}));

const TimerDisplay = styled(Box)(({ theme }) => ({
  backgroundColor: "#444",
  padding: "16px",
  borderRadius: "8px",
  textAlign: "center",
  color: "#fff",
  marginTop: theme.spacing(2),
}));

const BidNow = () => {
  const {socket} = useSocket();
  const [roomId, setRoomId] = useState("");
  const [auctionIdValue, setAuctionIdValue] = useState("");
  const [highestBid, setHighestBid] = useState(0);
  const [highestBidder, setHighestBidder] = useState("");
  const [userBidsHistory, setUserBidsHistory] = useState([]);
  const [auctionStatus, setAuctionStatus] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [auctionData, setAuctionData] = useState({});
  const [auctionLiveStatus,setAuctionLiveStatus] = useState("live");

  const { id, auctionId } = useParams();
  const { token, user } = useSelector((state) => state.auth);


  useEffect(() => {
    if (id) {
      setRoomId(id);
      setAuctionIdValue(auctionId);
    }
  }, [id, auctionId]);

  useEffect(() => {
    console.log(socket,">>>>>>>>>>>>>>>>>>>?????????")
   
    if (roomId && socket && auctionIdValue) {
      socket.emit("joinRoom", roomId, auctionIdValue);
    }
  }, [roomId, socket, auctionIdValue]);

  useEffect(() => {
    if (!socket) return;

    socket.on("event", setAuctionData);
    socket.on("auctionStatus", (data)=>{
      setAuctionStatus(data.auctionStatus);
    });
    socket.on("ticket-status", (data)=>{
      setAuctionLiveStatus(data);
    });
    socket.on("auctionStartCountdown", (data) => {
      if (data.roomId === roomId) {
        setTimeLeft(data?.timeLeft);
      }
    });
    socket.on("timerUpdate", (data) => {
      if (data.roomId === roomId) {
        setTimeLeft(data?.timeLeft);
      }
    });
    socket.on("currentBid", ({ bid, highestBidder, usersWallet, room }) => {
      if (room === roomId) {
        setHighestBid(bid);
        setHighestBidder(highestBidder);
      }
    });

    socket.on("userBids", ({ bidHistoryForRoom, room }) => {
      if (room === roomId) {
        setUserBidsHistory(bidHistoryForRoom);
      }
    });
    socket.on("newBid", ({ currentBid, highestBidder, usersWallet, room }) => {
      if (room === roomId) {
        setHighestBid(currentBid);
        setHighestBidder(highestBidder);
      }
    });
    socket.on("adminAuctionNotification", (data) => {
      toast.success(data?.message, {
        toastId: "auction-notification",
        autoClose: 5000,
      });
    });

    return () => {
      [
        "event",
        "auctionStatus",
        "auctionStartCountdown",
        "timerUpdate",
        "currentBid",
        "userBids",
        "newBid",
        "adminAuctionNotification",
      ].forEach((event) => socket.off(event));
    };
  }, [socket,token, roomId]);

  // Auction Control Actions
  const handleStartAuction = () => socket.emit("startAuction", {roomId,auctionId});
  const handlePauseAuction = () => socket.emit("pauseAuction", {roomId,auctionId});
  const handleResumeAuction = () => socket.emit("resumeAuction", {roomId,auctionId});
  const handleEndAuction = () => socket.emit("endAuction", {roomId,auctionId});

  const StatusBadge = styled(Box)(({ status }) => ({
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "20px",
    fontWeight: "bold",
    textTransform: "uppercase",
    textAlign: "center",
    color: "#fff",
    backgroundColor:
      status === "live"
        ? "#28a745" // Green for Live
        : status === "upcoming"
        ? "#ffc107" // Yellow for Upcoming
        : "#dc3545", // Red for Ended
  }));

return (
  <Box>
    <CardLayout>
      <CardContent>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Live Auction Dashboard
        </Typography>

        {/* Auction Status Badge */}
        <Grid container justifyContent="center">
          <StatusBadge status={auctionLiveStatus}>
            {auctionLiveStatus === "live"
              ? "Live Auction"
              : auctionLiveStatus === "upcoming"
              ? "Upcoming Auction"
              : auctionLiveStatus === "paused"
              ? "Paused Auction"
              : auctionLiveStatus === "completed" ||
                auctionLiveStatus === "expired"
              ? "Auction Ended"
              : "Unknown Status"}
          </StatusBadge>
        </Grid>

        <Grid container spacing={3}>
          {/* Auction Image */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center" mt={2}>
              <Avatar
                src={`${IMAGE_BASE}${auctionData?.image}`}
                alt="Auction Item"
                sx={{ width: 120, height: 120, border: "3px solid #6a0dad" }}
              />
            </Box>
          </Grid>

          {/* Auction Name */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Auction Item"
              value={auctionData?.name || ""}
              InputLabelProps={{ shrink: true }}
              disabled
            />
          </Grid>

          {/* Auction Control Actions */}
          <Grid item xs={12}>
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="contained"
                color="success"
                onClick={handleStartAuction}
                disabled={
                  auctionLiveStatus === "completed" ||
                  auctionLiveStatus === "expired" ||
                  auctionLiveStatus === "live" ||
                  auctionLiveStatus === "paused"
                }
              >
                Start Auction
              </Button>
              <Button
                variant="contained"
                color="warning"
                onClick={handlePauseAuction}
                disabled={
                  auctionLiveStatus === "completed" ||
                  auctionLiveStatus === "expired" ||
                  auctionLiveStatus === "paused" ||
                  auctionLiveStatus === "upcoming"
                }
              >
                Pause Auction
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={handleResumeAuction}
                disabled={
                  auctionLiveStatus === "completed" ||
                  auctionLiveStatus === "expired" ||
                  auctionLiveStatus === "live" ||
                  auctionLiveStatus === "upcoming"
                }
              >
                Resume Auction
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleEndAuction}
                disabled={
                  auctionLiveStatus === "completed" ||
                  auctionLiveStatus === "expired" ||
                  auctionLiveStatus === "upcoming"
                }
              >
                End Auction
              </Button>
            </Stack>
          </Grid>

          {/* Auction States */}
          {auctionLiveStatus === "upcoming" ? (
            // Upcoming auction: show countdown to start
            <Grid item xs={12}>
              <TimerDisplay>
                <Typography variant="h4">{timeLeft || "N/A"}</Typography>
                <Typography>Time Until Auction Starts</Typography>
              </TimerDisplay>
            </Grid>
          ) : auctionLiveStatus === "completed" ||
            auctionLiveStatus === "expired" ? (
            // Completed/Expired auction: show final bid + history
            <>
              <Grid item xs={12}>
                <TimerDisplay>
                  <Typography variant="h4">Auction Ended</Typography>
                  <Typography>
                    Final Bid: ${highestBid?.toFixed(2) || "0.00"}
                  </Typography>
                  <Typography>
                    Winner: {highestBidder || "No winner"}
                  </Typography>
                </TimerDisplay>
              </Grid>

              {/* Bids History Table */}
              <Grid item xs={12}>
                <TableContainer
                  component={Paper}
                  sx={{
                    backgroundColor: "#1c1c1e",
                    mt: 2,
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ color: "#fff" }}>Bid Amount</TableCell>
                        <TableCell sx={{ color: "#fff" }}>User</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Time</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userBidsHistory.length > 0 ? (
                        [...userBidsHistory].reverse().map((bid, idx) => (
                          <TableRow key={idx} sx={{ height: "50px" }}>
                            <TableCell sx={{ color: "#fff" }}>
                              ${bid?.bid?.toFixed(2)}
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }}>
                              {bid?.username}
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }}>
                              {new Date(bid?.time).toLocaleString()}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow sx={{ height: "250px" }}>
                          <TableCell
                            sx={{ color: "#fff", textAlign: "center" }}
                            colSpan={3}
                          >
                            No bid history available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </>
          ) : (
            // Live or paused auction
            <>
              {/* Current Highest Bid */}
              <Grid item xs={12}>
                <InfoBox>
                  <Typography variant="h6">
                    {highestBidder || "No bids placed yet"}
                  </Typography>
                  <Typography variant="h4">
                    ${highestBid?.toFixed(2) || "0.00"}
                  </Typography>
                </InfoBox>
              </Grid>

              {/* Bids History Table */}
              <Grid item xs={12}>
                <TableContainer
                  component={Paper}
                  sx={{
                    backgroundColor: "#1c1c1e",
                    mt: 2,
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ color: "#fff" }}>Bid Amount</TableCell>
                        <TableCell sx={{ color: "#fff" }}>User</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Time</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userBidsHistory.length > 0 ? (
                        [...userBidsHistory].reverse().map((bid, idx) => (
                          <TableRow key={idx} sx={{ height: "50px" }}>
                            <TableCell sx={{ color: "#fff" }}>
                              ${bid?.bid?.toFixed(2)}
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }}>
                              {bid?.username}
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }}>
                              {new Date(bid?.time).toLocaleString()}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow sx={{ height: "250px" }}>
                          <TableCell
                            sx={{ color: "#fff", textAlign: "center" }}
                            colSpan={3}
                          >
                            No bid history available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              {/* Active Auction Timer */}
              <Grid item xs={12}>
                <TimerDisplay>
                  <Typography variant="h4">{timeLeft || "N/A"}</Typography>
                  <Typography>
                    {auctionLiveStatus === "paused"
                      ? "Auction Paused"
                      : "Time Remaining"}
                  </Typography>
                </TimerDisplay>
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </CardLayout>
  </Box>
);


};

export default BidNow;
